import styles from "./General.module.css";
import logo from "../../../assets/image/logo.png";

export default function FaltandoUmParametro() {
    return (
        <section className={styles.General}>
            <img src={logo} alt="Logo do ISM" />

            <span> Está faltando um dos parâmetros necessários para o redirecionamento: o link precisa do código da campanha e do ID do influenciador. </span>
        </section>
    )
}